import React from 'react';

export function ApprenticeSelector({ apprentices, active, onChange }) {
  if (!apprentices || apprentices.length <= 1) return null;

  return (
    <div className="atabs">
      {apprentices.map(a => (
        <button
          key={a.id}
          className={`atab${active === a.id ? ' on' : ''}`}
          onClick={() => onChange(a.id)}
        >
          {a.name}
          {a.archived_at && <span style={{ opacity: 0.6, fontSize: 10, marginLeft: 5 }}>· archived</span>}
        </button>
      ))}
    </div>
  );
}
